import {Component, Input} from '@angular/core';
@Component({
  selector: 'app-grey-card-with-title',
  templateUrl: './grey-card-with-title.component.html',
  styleUrl: './grey-card-with-title.component.scss'
})
export class GreyCardWithTitleComponent {
  @Input() title: string | undefined;
  @Input() removeContentPaddingTop: boolean = false;
  @Input() showLogo: boolean = false;
  @Input() setHeadingMaxWidth350: boolean = true;
}
